






















































	import { Component, Vue, Watch, Provide, Prop } from 'vue-property-decorator';
	import SupplierJson from "@/doc/Supplier.json";
	import { nxExtenManageClient } from "@/api/nxExtenManageClient";
	import { AddExtenPhoneReq,OperateExtenPhoneReq } from "@/pbjs/xcommon/nxExtenManage_pb";
	import { setCommon, errorMsg } from "@/utils/request";
	const NxteleList = () => import('@/components/NxteleList/index.vue');
	@Component({
		name: 'system',
		components: {
			NxteleList
		}
	})
	export default class CombinationProperty extends Vue {
		@Prop() providerOptions!: any; // 供应商options
        @Prop() symphoneList!: any; // 供应商options
		@Provide() private country: any = localStorage.getItem("country"); // 国家，字段差异化展示
		@Provide() private nxnameOptions: any = [
			{
				id: 4,
				value: 'aa'
			}
		]
		@Provide() private nationValue: string = "";
		@Provide() private token: string | null = "";
		@Provide() private isaddExuser: string='3';
		@Provide() private isdisabled: boolean=false;
		@Provide() private rules: any = {
			ExtNumberStart: [
				{ required: true, message: '请输入', trigger: 'blur' }
			],
			ExtNumberEnd: [
				{ required: true, message: '请输入', trigger: 'blur' },
			],
			AccountNumberStart: [
				{ required: true, message: '请输入', trigger: 'blur' },
			],
			AccountNumberEnd: [
				{ required: true, message: '请输入', trigger: 'blur' },
			],
			SuplierType: [
			    { required: true, message: '请选择活动资源', trigger: 'change' }
			],
			NxteleId: [
			    { required: true, message: '请选择活动资源', trigger: 'change' }
			],
			AccountNumber: [
			    { required: true, message: '请输入', trigger: 'blur' },
				{ type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
			],
			password: [
			    { required: true, message: '请输入', trigger: 'blur' },
			]
		};

		@Provide() private newPhone: any = {
			SuplierType : "",
			NxteleId  : "",
			ExtNumberStart   : "",
			ExtNumberEnd   : "",
			AccountNumberStart: "",
			AccountNumberEnd: "",
			Id    : "",
            AccountNumber:'',
			password:'',
			// assignstatus:'',
			// ExtNumber:''
		};
		private NxteleIdChange(role:any){
			this.newPhone.NxteleId = role ? role.id : "";
		}
		get NxteleData(): any {
			return this.$store.getters.NXTELE_INFO;
		} //  角色
		private created() {
			this.token = localStorage.getItem("token");
			if (this.symphoneList.suptelename=="symphony") {
				this.isaddExuser='1'
				this.isdisabled=true
				this.newPhone.SuplierType=this.symphoneList.suptelename
				this.newPhone.NxteleId=this.symphoneList.nxteleid
				this.newPhone.Id=this.symphoneList.id
				this.newPhone.AccountNumber=this.symphoneList.extuser
				this.newPhone.password=this.symphoneList.extpwd
			}
			
		}
		private mounted(): void {
		}

		private submitForm(formName: string) {
			const ref: any = this.$refs[formName];
			ref.validate((valid: boolean) => {
				if (valid) {
					if (this.isdisabled) {
						this.OperateExtenPhonerequest()
					}else{
						this.addExtenPhone()
					}
					// if (this.isaddExuser=='1') {
					// 	this.addExtenPhone()
					// }else{
					// 	this.addExtenPhone();
					// }
				} else {
					return false;
				}
			});
		}
		//选择三方
	private	changeSuplierType(value:any){
	   if (value==8) {
		   this.isaddExuser="1"
	   } else if (value == 11) {
		   this.isaddExuser="4"
	   } else{
		   this.isaddExuser="2"
	   }
	   
	}

// lee cancel操作
	private resetForm(formName: string) {
			(this.$refs[formName] as any).resetFields();
			this.closeAddDialog(false);
		}
// lee 关闭弹窗
		private closeAddDialog(bool: boolean) {
			this.$emit('hideDialog', {
				hide: false,
				isAdd: bool
			});
		}
//添加账号密码
private OperateExtenPhonerequest() {
	let request: any = new OperateExtenPhoneReq();
	request.setCommonin(setCommon());
	request.setSupliertype(Number(this.newPhone.SuplierType));
	request.setNxteleid(this.newPhone.NxteleId);
	// request.setExtnumberstart(Number(this.newPhone.ExtNumberStart));
	// request.setExtnumberend(Number(this.newPhone.ExtNumberEnd));
	request.setId(Number(this.newPhone.Id));
	request.setExtuser(this.newPhone.AccountNumber);
	request.setExtpwd(this.newPhone.password)
	request.setExtnumber(Number(this.symphoneList.extnumber));
	request.setAssignstatus(Number(this.symphoneList.assignstatus));
	// request.setOperate(this.isdisabled?2:1);     
	request.setAssignid()
    request.setOpuid()
	// request.addIds()
	nxExtenManageClient.updateExtenPhone(request, {}, (err: any, response:any) => {
		if(response) {
					let data: any = response.toObject();
					if(data.commonout){
						if (data.commonout.code == 0) {
							this.$message.success("successfully");
							this.closeAddDialog(true);
						} else {
							this.$message.error(data.commonout.errmsg);
						}
					}else{
						if (data.code == 0) {
							this.$message.success("successfully");
							this.closeAddDialog(true);
						} else {
							this.$message.error(data.errmsg);
						}
					}
				}
				if (err) {
       errorMsg(err);
      }
	})
}

// lee 添加分机号码
		private addExtenPhone() {
			let request: any = new AddExtenPhoneReq();
			request.setCommonin(setCommon());
			request.setSupliertype(Number(this.newPhone.SuplierType));
			request.setNxteleid(this.newPhone.NxteleId);
			request.setExtnumberstart(Number(this.newPhone.ExtNumberStart));
			request.setExtnumberend(Number(this.newPhone.ExtNumberEnd));
			request.setId(Number(this.newPhone.Id));
			request.setExtuser(this.newPhone.AccountNumber);
	        request.setExtpwd(this.newPhone.password);
			request.setExtuserstart(Number(this.newPhone.AccountNumberStart));
			request.setExtuserend(Number(this.newPhone.AccountNumberEnd));
			nxExtenManageClient.addExtenPhone(request, {}, (err: any, response:any) => {
				if(response) {
					let data: any = response.toObject();
					if(data.commonout){
						if (data.commonout.code == 0) {
							this.$message.success("successfully");
							this.closeAddDialog(true);
						} else {
							this.$message.error(data.commonout.errmsg);
						}
					}else{
						if (data.code == 0) {
							this.$message.success("successfully");
							this.closeAddDialog(true);
						} else {
							this.$message.error(data.errmsg);
						}
					}
				}
				if (err) {
       errorMsg(err);
      }
			});
		}
	}
